export const NA_VALUE = "N/A"

export const MONTH_IN_SECONDS = 30 * 24 * 60 * 60
export const YEAR_IN_SECONDS = 365 * 24 * 60 * 60

export const RUNTIME_ID = "runtime"

export const FIXABLE_DATA_ID_ANALYTIC_FUNNEL_CARD = "fixable-funnel-card"

export const SUPPORT_EMAIL = "support@kodemsecurity.com"

export const NO_VALUE_PLACEHOLDER = "-"

export const COMMIT_HASH_MAX_LENGTH = 7

export const API_BASE_PATH = "/api"
